var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sModal',{attrs:{"body-style":'padding: 0; overflow: hidden;',"closable":false,"content-classes":_vm.contentClass,"footer-hide":"","fullscreen":_vm.fullscreen,"transfer":""},scopedSlots:_vm._u([{key:"activator",fn:function(slotProps){return [_vm._t("activator",null,null,{
        ...slotProps,
        on: {
          click: () => { _vm.valueMutable = true }
        }
      })]}}],null,true),model:{value:(_vm.valueMutable),callback:function ($$v) {_vm.valueMutable=$$v},expression:"valueMutable"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }